import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setFullHeight } from '../../actions/uiActions';
import { clearTitleData } from '../../actions/titleActions';
import { loadContextualizedAudioQAData } from '../../actions/contextualizedAudioQATitleActions';
import { RedirectAs404 } from '../Error404';
import asyncComponent from '../../utils/async';


const AsyncContextualizedAudioQA = asyncComponent(() => import('../ContextualizedAudioQA'));

class ContextualizedAudioQATitle extends Component {
  componentDidMount () {
    const { actions, uid, name, slug, description, topics } = this.props;
    actions.loadContextualizedAudioQAData({ uid, name, slug, description, topics });
    actions.setFullHeight(false);
  }

  componentWillUnmount () {
    const { actions, uid } = this.props;
    actions.clearTitleData(uid);
  }

  render () {
    const { match, titleData } = this.props;
    if (Object.keys(titleData).length === 0) {
      // TODO: loading animation
      return null;
    }
    const { itemsBySlug, topics } = titleData;

    return (
      <div className="title-wrapper">
        <Switch>
          <Route exact path={match.url} render={props => {
            const firstSlug = topics[0].subtopics[0];
            return <Redirect to={`${match.url}/${firstSlug}`} />;
          }} />
          <Route exact path={`${match.url}/:itemSlug`} render={props => {
            const { itemSlug } = props.match.params;
            if (!itemsBySlug.hasOwnProperty(itemSlug)) {
              return <RedirectAs404 />;
            }
            return <AsyncContextualizedAudioQA activeItemSlug={itemSlug} baseUrl={match.url} {...titleData} />;
          }} />
          <Route component={RedirectAs404} />
        </Switch>
      </div>
    );
  }
}

ContextualizedAudioQATitle.propTypes = {
  uid: PropTypes.string.isRequired,
  titleData: PropTypes.object,
};

ContextualizedAudioQATitle.defaultProps = {
  titleData: {},
};

const mapStateToProps = ({ breakpoint, titles }, ownProps) => ({
  breakpoint,
  titleData: titles[ownProps.uid],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight, clearTitleData, loadContextualizedAudioQAData }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContextualizedAudioQATitle));



// WEBPACK FOOTER //
// ./src/components/Title/ContextualizedAudioQATitle.js